<template>
  <a @click="scrollTop" v-show="visible" class="bottom-right">
    <slot></slot>
  </a>
</template>

<script>
export default {
  data() {
    return {
      visible: false
    };
  },
  methods: {
    scrollTop: function () {
      // this.intervalId = setInterval(() => {
      //   if (window.pageYOffset === 0) {
      //     clearInterval(this.intervalId)
      //   }
      //   window.scroll(0, window.pageYOffset - 50)
      // }, 20)
      window.scrollTo(0, 0);
    },
    scrollListener: function (e) {
      this.visible = window.scrollY > 150;
    }
  },
  mounted: function () {
    window.addEventListener("scroll", this.scrollListener);
  },
  beforeDestroy: function () {
    window.removeEventListener("scroll", this.scrollListener);
  }
};
</script>

<style scoped>
  .bottom-right i {
    color: white;
  }

  .bottom-right {
    position: fixed;
    bottom: 30px;
    right: 30px;
    cursor: pointer;
    z-index: 999;
    padding: 7px 12px;
    background-color: #343a52;
    border-radius: 3px;
    color: white;
  }
</style>
